import { render, staticRenderFns } from "./FormFpregradcreate.vue?vue&type=template&id=eddb5de8&"
import script from "./FormFpregradcreate.vue?vue&type=script&lang=js&"
export * from "./FormFpregradcreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports